import React from 'react';
import styles from './FAQ.module.scss';
import Item from './Item.js';
import config from '../../../config/config';

import { compose } from 'redux';
import { withRouter } from 'react-router';

const FAQ = ({ showFaq, isPreRMDEligible, isPostLaunch }) => {
  const items = [
    {
      display: true,
      header: 'What is a RMD?',
      content: (
        <p>
          Generally, starting when you’re 73 (72 if you turned 72 between
          January 1, 2020 and December 31, 2022 or 70 ½ if you turned 70 ½
          before January 1, 2020), you’re required to take mandatory withdrawals
          from your Traditional, Rollover, SEP, and SIMPLE IRAs, and
          employer-sponsored retirement plans. (Please note that the RMD age
          will change again to 75 in 2033) This annual withdrawal is known as a
          required minimum distribution (RMD). Roth IRAs do not require
          withdrawals until after the death of the owner. Please note, different
          RMD rules apply to inherited retirement accounts. For questions
          relating to inherited retirement accounts, including IRAs, please
          speak to your legal or tax professional.
        </p>
      ),
    },
    {
      display: true,
      header: 'How do I calculate my Required Minimum Distribution (RMD)?',
      content: (
        <p>
          {' '}
          <p>
            Your RMD is determined by dividing your eligible account balance on
            December 31 of the previous year by your life expectancy factor for
            the calculation year. Your life expectancy factor corresponds with
            your age in the{' '}
            <a
              href="https://www.irs.gov/pub/irs-pdf/p590b.pdf#page=65"
              target="_blank"
            >
              IRS Uniform Lifetime Table (PDF)
            </a>
            . However, if your spouse is your sole beneficiary and is more than
            10 years younger than you, you will use the{' '}
            <a
              href="https://www.irs.gov/pub/irs-pdf/p590b.pdf#page=50"
              target="_blank"
            >
              IRS Joint Life and Last Survivor Expectancy Table (PDF)
            </a>
            .
          </p>
          <p>
            As these factors change each year, your RMD must also be
            recalculated each year.
          </p>
          <p>
            We’re able to help you calculate your RMDs based on IRAs at T. Rowe
            Price, but if you have IRAs with other companies, you’ll need to
            calculate the appropriate RMD for each.
          </p>
          <p>
            If you don’t take the correct RMD amount, it could have significant
            tax consequences and penalties.
          </p>
          <p>
            T. Rowe Price also offers a{' '}
            <a href={`${config.url}/usis/rmd-tool/calculator`} target="_blank">
              RMD Calculator
            </a>{' '}
            which allows you to manually determine an estimated RMD for prior,
            current and future years. Please note that this tool is for
            estimating purposes only and is based solely on the values you
            enter.
          </p>
        </p>
      ),
    },
    {
      display: true,
      header: 'How can I take my distribution?',
      content: (
        <p>
          <p style={{ marginBottom: '10px' }}>
            You can satisfy your RMD obligations through a one-time transaction
            or automatic withdrawals from retirement accounts.
          </p>
          <p>
            As a T. Rowe Price client, log in and set up your RMD from your T.
            Rowe Price Traditional and Rollover IRAs with our{' '}
            <a href={`${config.url}/usis/rmd-tool/start`}>
              Auto-RMD tool
            </a>.
            You can choose to send your RMD directly to your bank account,
            reinvest it in a T. Rowe Price taxable account, or have a check sent
            to your address on record.
          </p>{' '}
        </p>
      ),
    },
    {
      display: true,
      header: "What's the deadline for when I need to take my RMD?",
      content: (
        <p>
          {!isPostLaunch('2024-01-01T00:01:00-05:00') ? (
            "If you turned 72 prior to January 1, 2023, you must take your 2023 RMD before December 31st."
          ) : (
            "Generally, RMDs must be taken by December 31st. If December 31st occurs on a weekend, then you will need to ensure your RMD is taken prior to the last business day of the year."
          )}
          <br></br>
          <br></br>
          {!isPostLaunch('2024-01-01T00:01:00-05:00') ? (
            "If you turned 72 this year (on or after January 1, 2023), due to recent changes in the law, you are not required to take an RMD until the year you turn 73."
          ) : (
              "If you turned 73 this year, then you are eligible to defer your first RMD to April 1st of the following year. Note if the first year RMD is deferred, you will also need to fulfil your second year RMD by December 31st of that following year. If April 1st occurs on a weekend, then you will need to ensure your RMD is taken prior to the last business day in March."
          )}
          <br></br>
          <br></br>
          Non-IRA retirement plans, such as 401(k) or 403(b) plans, may have
          different deadlines. Please speak with your plan administrator for
          details.
          <br></br>
          <br></br>
          Request your distribution no later than one week prior to the
          deadline(s) to be sure that the RMD occurs before the due date.
          Otherwise, if you don’t meet your distribution deadline, the RMD may
          be considered late and could have significant tax consequences and
          penalties.
        </p>
      ),
    },
    {
      display: true,
      header: 'What happens if I don’t meet my RMD for the year?',
      content: (
        <p>
          Failure to meet your RMD by the deadline could have significant tax
          consequences and penalties.
          <br></br>
          <br></br>
          If an account owner fails to withdraw an RMD, fails to withdraw the
          full amount of the RMD, or fails to withdraw the RMD by the deadline,
          the amount not withdrawn may be assessed a penalty at a rate of 25%.
          The excise tax on certain RMD failures would be further reduced from
          25% to 10% if the failure is: (1) corrected during the “correction
          window”; and (2) the taxpayer submits a return during the correction
          period reflecting the excise tax. If you have any questions, see{' '}
          <a href="https://www.irs.gov/pub/irs-pdf/f5329.pdf" target="_blank">
            IRS Publication 590 and Instructions for Form 5329
          </a>{' '}
          and speak with your tax professional for further details.
        </p>
      ),
    },
    {
      display: true,
      header:
        'Can I make a Qualified Charitable Distribution (QCD) to fulfill my RMD?',
      content: (
        <p>
          Generally, you can distribute up to $105,000 for 2024 (indexed for inflation)
          directly from an IRA to qualified charities each year.  Beginning in
          2023, a QCD may be taken to fund a Charitable Remainder UniTrust,
          Charitable Remainder Annuity Trust, or Charitable Gift Annuity up to a
          maximum one-time amount of $50,000. QCDs can count toward your RMD and
          won’t be included in your taxable income. To make a QCD, the easiest
          way is to use our{' '}
          <a href={`${config.url}/usis/transactions/qcd/landing`}>
            online QCD flow
          </a>.{' '}
          You can also give us a call and complete the
          form digitally through DocuSign, which allows us to review the form to
          prevent errors and saves you the need to mail the form. If you’d like
          to handle the paperwork yourself, you must download and mail the{' '}
          <a
            href="https://www.troweprice.com/content/dam/iinvestor/Forms/qualified-charitable-distribution-ira.pdf"
            target="_blank"
          >
            QCD Form
          </a>{' '}
          within the required timeline.
        </p>
      ),
    },
    {
      display: true,
      header: 'What accounts require an RMD?',
      content: (
        <p>
          Account holders are required to take RMDs from their tax-deferred
          retirement accounts. These include Traditional, Rollover, SEP,
          and SIMPLE IRAs and employer-sponsored retirement plans. RMDs are not
          required for the original owner of a Roth IRA.  However, the
          beneficiaries of a Roth IRA do have RMD requirements. Inherited
          retirement accounts require RMDs as well; please speak to your legal
          or tax professional.
        </p>
      ),
    },
    {
      display: isPreRMDEligible,
      header: 'Can I take my whole amount from one IRA account?',
      content: (
        <p>
          If you have more than one IRA, you must calculate the appropriate RMD
          for each individually. However, you can take your total distribution
          from any one or more of the IRAs.
        </p>
      ),
    },
    {
      display: isPreRMDEligible,
      header: 'What if I have multiple accounts?',
      content: (
        <p>
          If you have more than one IRA, you must calculate the appropriate RMD
          for each individually. However, you can take your total distribution
          from any one or more of the IRAs. Similar rules apply to 403(b)
          accounts. However, RMDs from other types of retirement plans, such as
          401(k) plans, must be taken separately from each of those plan
          accounts.
        </p>
      ),
    },
    {
      display: true,
      header:
        'Does T. Rowe Price take into consideration my outside IRA when calculating my RMD?',
      content: (
        <p>
          We’re able to help you calculate your RMDs based on IRAs at T. Rowe
          Price, but if you have IRAs with other companies, you’ll need to
          calculate the appropriate RMD for each.
        </p>
      ),
    },
    {
      display: true,
      header: 'Where do I update beneficiaries?',
      content: (
        <p>
          If you’re a T. Rowe Price client, you can update your beneficiaries by
          logging in and visiting the{' '}
          <a
            href={`${config.url}/usis/my-accounts/profile/beneficiaries`}
            target="_blank"
          >
            Beneficiaries page.
          </a>
          <br></br>
          <br></br>
          Alternatively, you can update your beneficiaries using the{' '}
          <a
            href="https://www.troweprice.com/content/dam/iinvestor/Forms/IRABeneCh.pdf"
            target="_blank"
          >
            IRA Beneficiary form (PDF).
          </a>
        </p>
      ),
    },
    {
      display: isPreRMDEligible,
      header: 'How is income tax withholding applied on an RMD?',
      content: (
        <p>
          The default withholding rate for federal income tax withholding is 10%
          unless you choose to have a different rate between 0% and 100%
          applied. State income tax will be withheld from your distribution
          under the applicable state law if your address of record is in a state
          that defaults to income tax withholding.
          <br></br>
          <br></br>
          Qualified Roth distributions are tax-free and do not require income
          tax withholding. Generally, qualified Roth distributions are tax-free
          once you reach age 59.5 and have held the Roth account for at least
          five years.
        </p>
      ),
    },
    {
      display: true,
      header: 'Which tax form will my RMD be reported on?',
      content: (
        <p>
          Any amounts distributed from your IRA, including your RMD, will be
          reported on IRS Form 1099-R.
        </p>
      ),
    },
  ];
  return (
    <div className={styles['container']}>
      <div className={styles['text-section']}>
        <div className={styles['title']}>Frequently Asked Questions</div>
        <div className={styles['sub-title']}>
          {/* <BeaconIconButton size={20} variant="secondary" label="Add Button" >
            <img slot="icon" src={icon} alt=""/>
          </BeaconIconButton> */}
          <div className="app-component"></div>
          {showFaq && (
            <div>
              {items.map(({ display, header, content }, key) => (
                <Item
                  key={key}
                  display={display}
                  header={header}
                  content={content}
                ></Item>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default compose(withRouter)(FAQ);
